import React from "react";
import "./Sponsor.css"

const Sponsor = () => {

  const Elegance = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/elegance-logo.png"
  const DCA = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/sponsor-logo.png";
  const Voyage = "https://gladiator-website-amplify.s3.eu-west-2.amazonaws.com/pics/voyage-logo.png"

  const sponsors = [
    {
      id: 1,
      image: Elegance,
      alt: "Elegance Barbers",
      link: "https://elegancebarberspoole.co.uk"
    },
    {
      id: 2,
      image: Voyage,
      alt: "Voyage BH Cafe",
      link: "https://www.facebook.com/profile.php?id=100087457020209"
    },
    {
      id: 3,
      image: DCA,
      alt: "DCA - Digital Cloud Advisor",
      link: "https://www.digitalcloudadvisor.com"
    },
  ];

  return (
    <section className="sponsors-section">
      <h2 className="sponsors-title">Our Sponsors</h2>
      <div className="sponsors-container">
        {sponsors.map((sponsor) => (
          <div key={sponsor.id} className="sponsor-card">
            <a href={sponsor.link} target="_blank" rel="noopener noreferrer">
            <img src={sponsor.image} alt={sponsor.alt} className="sponsor-logo" />
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Sponsor;
